var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.accessToken
    ? _c(
        "section",
        {
          class: _vm.sectionClass,
          staticStyle: { "padding-top": "1rem", "padding-bottom": "0rem" },
        },
        [
          _c("div", { staticClass: "section-content" }, [
            _c(
              "div",
              {
                staticClass: "alert-box",
                staticStyle: { "margin-top": "1em" },
              },
              [
                _c(
                  "div",
                  { staticClass: "columns is-centered is-vcentered is-mobile" },
                  [
                    _vm._m(0),
                    _vm._m(1),
                    _c("div", { staticClass: "column last-column" }, [
                      _c(
                        "div",
                        { staticClass: "has-text-centered" },
                        [
                          _c("span", {
                            staticClass: "promo",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("home.promo_reale")),
                            },
                          }),
                          _c(
                            "router-link",
                            {
                              staticClass: "button is-primary",
                              attrs: { to: _vm.urlPromoCode },
                            },
                            [_vm._v(_vm._s(_vm.$t("button.send_coupon")))]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("img", { staticClass: "logo", attrs: { src: "/logo_simple.svg" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("img", {
        staticClass: "logo logo-reale",
        attrs: { src: "/img/reale_logo.png" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }